module.exports = __webpack_public_path__ + "static/media/icon-pencil.2edc171f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-pencil.svg
// module id = 953
// module chunks = 0